import InvoicesTrash from "./components/InvoicesTrash";

export default InvoicesTrash;
